<template>
  <div
    class="fixed w-full h-full bg-black bg-opacity-90 z-30 flex justify-center items-center"
  >
    <span class="close cursor-pointer z-50" @click="closeWindow"></span>
    <div
      class="max-w-1920 box-border block w-0 min-w-full tw-h-full carousel-wrapper"
    >
      <VueSlickCarousel
        v-bind="settings"
        class="class-carousel"
        ref="classCarousel"
      >
        <div
          class="class-wrapper w-full flex-row justify-center items-center sm:flex-col sm:mt-14"
          v-for="(slide, index) in classSlider"
          :key="index"
        >
          <div
            class="relative w-734 h-718 flex justify-center items-center -ml-52 sm:w-full sm:h-full sm:ml-auto"
          >
            <div
              class="absolute inset-0 m-auto bg-class-card w-504 h-670 bg-no-repeat bg-contain bg-top sm:w-316 sm:h-auto"
            ></div>
            <div class="relative w-full h-full">
              <img
                class="class-main-image -mt-24 sm:mt-auto"
                :src="`${imgPath}${slide.mainImage}`"
              />
            </div>
          </div>
          <div
            class="flex flex-col w-full max-w-487 -ml-36 z-10 xl:max-w-400 xl:-ml-60 sm:ml-0 sm:px-7"
          >
            <span
              class="font-elmessiri text-44 tracking-wider text-white text-shadow-name sm:text-30"
              v-html="slide.name"
            ></span>
            <p
              class="font-nunito text-grayish-orange mt-6 sm:text-xs sm:mt-0 sm:overflow-y-scroll sm:max-h-162"
              v-html="slide.desc"
            ></p>
            <div class="w-full flex flex-row justify-between mt-6 sm:hidden">
              <a
                v-for="(video, vIndex) in slide.video"
                :key="vIndex"
                data-lity
                :href="video.src"
                class="w-56 h-139 border border-grayish-orange rounded-sm bg-no-repeat bg-center bg-cover"
                :style="{
                  'background-image':
                    'url(https://img.youtube.com/vi/' +
                    video.bg +
                    '/hqdefault.jpg)',
                }"
              >
              </a>
            </div>
          </div>
        </div>
        <template #prevArrow="arrowOption">
          <div
            class="bg-prev-arrow bg-center bg-cover w-152 h-152 cursor-pointer m-auto z-20 absolute top-1/2 left-0.5/10 transform translate-x-0 -translate-y-1/2 xl:left-0 sm:w-24 sm:h-24 sm:left-0"
          ></div>
        </template>
        <template #nextArrow="arrowOption">
          <div
            class="bg-next-arrow bg-center bg-cover w-152 h-152 cursor-pointer m-auto z-20 absolute top-1/2 right-0.5/10 transform translate-x-0 -translate-y-1/2 xl:right-0 sm:w-24 sm:h-24 sm:right-0"
          ></div>
        </template>
      </VueSlickCarousel>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapGetters } from 'vuex';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
export default {
  components: { VueSlickCarousel, CoolLightBox },
  props: {
    classSlider: Array,
  },
  watch: {
    activeClassSlide: function(newValue, oldValue) {
      //console.log(newValue);
      this.$refs.classCarousel.goTo(newValue, true);
    },
    mainSliderActive: function(newValue, oldValue) {
      if (newValue) {
        this.initClassAnimation();
      } else {
        this.disableClassAnimation();
      }
    },
    subSliderActive: function(newValue, oldValue) {
      if (newValue) {
        this.initClassAnimation();
      } else {
        this.disableClassAnimation();
      }
    },
  },
  data: function() {
    return {
      imgPath: process.env.VUE_APP_IMG_URL,
      settings: {
        arrows: true,
        dots: false,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    };
  },
  methods: {
    closeWindow: function() {
      this.$store.commit('CLASS_SECTION/CLOSE_WINDOW');
    },
    initClassAnimation: function() {
      this.$store.commit('ANIMATION/ACTIVE_CLASS_SLIDER');
    },
    disableClassAnimation: function() {
      this.$store.commit('ANIMATION/DISABLE_CLASS_SLIDER');
    },
  },
  computed: {
    ...mapState({
      activeSlide: state => state.ClassSection.activeSlide,
    }),
    ...mapGetters(['activeClassSlide', 'mainSliderActive', 'subSliderActive']),
  },
};
</script>

<style lang="postcss" scoped>
.close {
  @apply absolute right-16 top-12 w-8 h-8 sm:right-6 sm:top-6;
}
.close:before,
.close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 33px;
  width: 2px;
  background-color: #f1dcac;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}
.class-carousel >>> .slick-list {
  @apply w-full h-1087 sm:h-auto;
  /* height: 1087px; */
}
.class-carousel >>> .slick-list .slick-track .slick-slide {
  @apply w-full relative flex justify-center items-center h-1087 sm:h-auto;
}
.class-wrapper {
  @apply flex !important;
}
</style>
